import { render, staticRenderFns } from "./CmgGuacModeJoinRewardsModal.vue?vue&type=template&id=3544ea69&scoped=true&lang=pug&"
import script from "./cmg-guac-mode-join-rewards-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-guac-mode-join-rewards-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgGuacModeJoinRewardsModal.vue?vue&type=style&index=0&id=3544ea69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3544ea69",
  null
  
)

export default component.exports